var exports = {
  "aw": "slider__8gUujT",
  "AS": "item__c_SeQ9",
  "RP": "exiting__OyhaY1",
  "GY": "slide-up__DBh35U",
  "Hu": "entering___bwnUw",
  "Uu": "slide-in__LanCUL",
};

module.exports = exports;
